module.exports = __webpack_public_path__ + "static/02_Track-User-testing.5bf07f1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/auspost/02_Track-User-testing.jpg
// module id = 476
// module chunks = 110568472390859